import "../App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AddMedications from "./AddMedications";
import DrugTable from "./DrugTable";
import Home from "./Home";
import Footer from "./Footer";
import Header from "./Header";
import MedState from "../context/MedState";

function App() {
  return (
    <>
      <MedState>
        <Router>
          <Header />
          <Routes>
            {/* Using exact to avoid partial matching of url */}
            <Route exact path="/" element={<Home />} />
            <Route exact path="/drugs" element={<AddMedications />} />
            <Route exact path="/result" element={<DrugTable />} />
          </Routes>
          <Footer />
        </Router>
      </MedState>
    </>
  );
}

export default App;
